/**
 * 초기 페이지 진입 팝업 설정.
 *
 * 팝업을 추가하거나 비활성화할 때 UI 컴포넌트를 수정하지 않고
 * `items`만 관리하면 됩니다.
 */
export interface InitialPopupItem {
  /** localStorage에 저장되는 안정적인 식별자 */
  id: string
  /** 팝업 이미지 주소 */
  image: string
  /** 이미지 대체 텍스트 */
  alt: string
  /** false로 설정하면 설정에서만 임시 비활성화됩니다. */
  enabled: boolean
}

export const INITIAL_POPUP_SETTINGS = {
  /** 오늘 그만보기 상태를 저장할 localStorage 키의 접두사 */
  storageKey: 'yoomai-popup-dismissed',
  // 공지 이미지가 준비되면 이 배열에 항목을 추가해 초기 팝업을 활성화합니다.
  items: [] as InitialPopupItem[],
} as const
